import React, { FC, useState, useEffect } from "react";
import TagManager from "react-gtm-module";
import { Helmet, HelmetProvider } from "react-helmet-async";

import { getPageContent } from "src/api";
import { Preloader, Accordeon } from "src/components";
import { SeoMeta } from "src/types";
import { generateMetaTags } from "src/utils";

import {
  Container,
  PaymentPage,
  Content,
  DeliveryText,
} from "./DeliveryPage.styles";
type IProps = {
  url: string;
};

const DeliveryPage: FC<IProps> = ({ url }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [content, setContent] = useState<any | null>(null); //  eslint-disable-line @typescript-eslint/no-explicit-any

  const seoTitle = "Доставка";
  const seoDescription =
    "Доставка. Leform: концептуальный интернет-магазин одежды, обуви, аксессуаров и предметов интерьера";
  const metaTags: SeoMeta[] = generateMetaTags(seoTitle, seoDescription);

  useEffect(() => {
    setIsLoading(true);
    getPageContent(url)
      .then(({ data }) => {
        setContent(data);
      })
      .finally(() => setIsLoading(false));
  }, [url]);

  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: "pageview",
      },
    });
  }, []);

  return (
    <Container>
      <HelmetProvider>
        <Helmet defer={false} title={seoTitle} meta={metaTags} />
      </HelmetProvider>
      {isLoading ? (
        <Preloader />
      ) : (
        <PaymentPage>
          {content && (
            <>
              <DeliveryText
                dangerouslySetInnerHTML={{ __html: content["delivery-text"] }}
              ></DeliveryText>
              {content["delivery-items"].map(
                (item: { title: string; text: string; id: number }) => {
                  return (
                    <Accordeon
                      header={item.title}
                      content={
                        <Content
                          dangerouslySetInnerHTML={{ __html: item.text }}
                        ></Content>
                      }
                    ></Accordeon>
                  );
                }
              )}
            </>
          )}
        </PaymentPage>
      )}
    </Container>
  );
};

export default DeliveryPage;
